export const CONFIG = {
    contentfulApplicationTagId: 'b2c',

    mathleticsForSchoolsUrl: 'https://www.mathletics.com/au/for-schools',
    signInUrl: 'https://parent.3plearning.com/s/login',
    forgotPasswordUrl: 'https://parent.3plearning.com/s/login/ForgotPassword'
};
